import { render, staticRenderFns } from "./MainManage.vue?vue&type=template&id=343c35cf&scoped=true&"
import script from "./MainManage.vue?vue&type=script&lang=ts&"
export * from "./MainManage.vue?vue&type=script&lang=ts&"
import style0 from "./MainManage.vue?vue&type=style&index=0&id=343c35cf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343c35cf",
  null
  
)

export default component.exports